<section class="blog-filter">
  @if (isValid()) {
    <header class="blog-filter-header">
      <p class="blog-filter-count">
        {{ posts().length }}
        {{ posts().length === 1 ? "post" : "posts" }}
      </p>
    </header>

    @if (posts().length > 0) {
      <ol class="blog-filter-list" aria-label="Posts at this level">
        @for (post of posts(); track post.slug) {
          <li>
            <app-blog-post-card [post]="post" />
          </li>
        }
      </ol>
    } @else {
      <p class="blog-filter-empty">
        No posts at this level yet — check back soon.
      </p>
    }
  } @else {
    <p class="blog-filter-empty">
      That level doesn't exist.
      <a routerLink="/blog">Browse all posts</a>
      instead.
    </p>
  }
</section>

<app-page-cta location="bottom" />
